function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "ttrl");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-31.31,207.94c2.44-.81,514-147.2,514-147.2",
  transform: "translate(33.2 14.69)",
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  x1: 185.51,
  y1: 57.1,
  x2: 385.11,
  y2: 394.3,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  x1: 385.11,
  y1: 29.97,
  x2: 173.88,
  y2: 334.22,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref6 =
/*#__PURE__*/
React.createElement("line", {
  x1: 20.78,
  y1: 334.22,
  x2: 454.88,
  y2: 469.88,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref7 =
/*#__PURE__*/
React.createElement("line", {
  x1: 505.26,
  y1: 243.14,
  x2: 104.11,
  y2: 497.01,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref8 =
/*#__PURE__*/
React.createElement("line", {
  x1: 47.91,
  y1: 91.98,
  x2: 304.69,
  y2: 522.2,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref9 =
/*#__PURE__*/
React.createElement("line", {
  x1: 454.88,
  y1: 0.9,
  x2: 377.36,
  y2: 512.51,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref10 =
/*#__PURE__*/
React.createElement("line", {
  x1: 258.89,
  y1: 57.1,
  x2: 553.71,
  y2: 361.35,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref11 =
/*#__PURE__*/
React.createElement("line", {
  x1: 544.02,
  y1: 159.81,
  x2: 104.11,
  y2: 433.06,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref12 =
/*#__PURE__*/
React.createElement("line", {
  x1: 57.6,
  y1: 274.15,
  x2: 483.95,
  y2: 149.03,
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1196.85,300.16",
  transform: "translate(33.2 14.69)",
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1328.63,156.75",
  transform: "translate(33.2 14.69)",
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 12
});

var SvgTtrl = function SvgTtrl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "ac5e5c58-80a4-433d-a02e-9d44bb66e60d",
    "data-name": "Layer 1",
    viewBox: "0 0 558.02 525.28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTtrl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ttrl.dd9be9b7.svg";
export { ForwardRef as ReactComponent };